function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.368,
  y: 0.368,
  width: 10.088,
  height: 8.265,
  rx: 2.579,
  fill: "url(#all-menu-color_svg__paint0_linear_3125_814)"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.368,
  y: 0.368,
  width: 10.088,
  height: 8.265,
  rx: 2.579,
  stroke: "url(#all-menu-color_svg__paint1_linear_3125_814)",
  strokeWidth: 0.737
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.368,
  y: 0.368,
  width: 10.088,
  height: 8.265,
  rx: 2.579,
  stroke: "url(#all-menu-color_svg__paint2_linear_3125_814)",
  strokeWidth: 0.737
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 12.396,
  y: 14.218,
  width: 10.088,
  height: 8.265,
  rx: 2.579,
  fill: "url(#all-menu-color_svg__paint3_linear_3125_814)"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 12.396,
  y: 14.218,
  width: 10.088,
  height: 8.265,
  rx: 2.579,
  stroke: "url(#all-menu-color_svg__paint4_linear_3125_814)",
  strokeWidth: 0.737
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 12.396,
  y: 14.218,
  width: 10.088,
  height: 8.265,
  rx: 2.579,
  stroke: "url(#all-menu-color_svg__paint5_linear_3125_814)",
  strokeWidth: 0.737
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 12.396,
  y: 0.368,
  width: 10.088,
  height: 11.728,
  rx: 2.579,
  fill: "url(#all-menu-color_svg__paint6_linear_3125_814)"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 12.396,
  y: 0.368,
  width: 10.088,
  height: 11.728,
  rx: 2.579,
  stroke: "url(#all-menu-color_svg__paint7_linear_3125_814)",
  strokeWidth: 0.737
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 12.396,
  y: 0.368,
  width: 10.088,
  height: 11.728,
  rx: 2.579,
  stroke: "url(#all-menu-color_svg__paint8_linear_3125_814)",
  strokeWidth: 0.737
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 0.368,
  y: 10.756,
  width: 10.088,
  height: 11.728,
  rx: 2.579,
  fill: "url(#all-menu-color_svg__paint9_linear_3125_814)"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 0.368,
  y: 10.756,
  width: 10.088,
  height: 11.728,
  rx: 2.579,
  stroke: "url(#all-menu-color_svg__paint10_linear_3125_814)",
  strokeWidth: 0.737
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 0.368,
  y: 10.756,
  width: 10.088,
  height: 11.728,
  rx: 2.579,
  stroke: "url(#all-menu-color_svg__paint11_linear_3125_814)",
  strokeWidth: 0.737
});

var _ref13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "all-menu-color_svg__paint0_linear_3125_814",
  x1: 0.314,
  y1: 5.836,
  x2: 5.892,
  y2: 12.898,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEB31A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "all-menu-color_svg__paint1_linear_3125_814",
  x1: 0,
  y1: 4.501,
  x2: 10.825,
  y2: 4.501,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F58220"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BA001B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "all-menu-color_svg__paint2_linear_3125_814",
  x1: -0.677,
  y1: 5.662,
  x2: 5.501,
  y2: 13.305,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EF2B24"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "all-menu-color_svg__paint3_linear_3125_814",
  x1: 12.341,
  y1: 19.686,
  x2: 17.92,
  y2: 26.748,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEB31A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "all-menu-color_svg__paint4_linear_3125_814",
  x1: 12.027,
  y1: 18.351,
  x2: 22.852,
  y2: 18.351,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F58220"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BA001B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "all-menu-color_svg__paint5_linear_3125_814",
  x1: 11.35,
  y1: 19.512,
  x2: 17.529,
  y2: 27.155,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EF2B24"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "all-menu-color_svg__paint6_linear_3125_814",
  x1: 12.341,
  y1: 8.081,
  x2: 20.249,
  y2: 15.311,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEB31A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "all-menu-color_svg__paint7_linear_3125_814",
  x1: 12.027,
  y1: 6.232,
  x2: 22.852,
  y2: 6.232,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F58220"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BA001B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "all-menu-color_svg__paint8_linear_3125_814",
  x1: 11.35,
  y1: 7.84,
  x2: 20.044,
  y2: 15.607,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EF2B24"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "all-menu-color_svg__paint9_linear_3125_814",
  x1: 0.314,
  y1: 18.468,
  x2: 8.222,
  y2: 25.699,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEB31A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "all-menu-color_svg__paint10_linear_3125_814",
  x1: 0,
  y1: 16.619,
  x2: 10.825,
  y2: 16.619,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F58220"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BA001B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "all-menu-color_svg__paint11_linear_3125_814",
  x1: -0.677,
  y1: 18.227,
  x2: 8.017,
  y2: 25.995,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EF2B24"
})));

function SvgAllMenuColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

export default SvgAllMenuColor;